import React from "react";
import { TextInput, SelectInput } from "react-admin";
import "../../common/styles/TwoInputsInRow.css";
import { IDropDownAppData } from "../../../common/redux/reducers/appDataReducer";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface YearColorSelectorProps {
  years: Array<IDropDownAppData<number>>;
}

export const YearColorSelector = (props: YearColorSelectorProps) => {
  const { years, ...rest } = props;
  return (
    <div className="two-inputs-container">
      <ProtectedElement source="year">
        <SelectInput
          source="year"
          label="resources.admin-vehicles.labels.year"
          choices={years}
          {...rest}
        />
      </ProtectedElement>
      <ProtectedElement source="color">
        <TextInput
          source="color"
          label="resources.admin-vehicles.labels.color"
          {...rest}
        />
      </ProtectedElement>
    </div>
  );
};
